import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/administration/user-groups/$groupId/permissions/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/administration/user-groups/$groupId/permissions/$page/$limit',
      params: { groupId: params.groupId, page: '1', limit: '10' },
    });
  },
});
